import { endingSteps } from "@faire/retailer-visitor-shared/views/SignUp/signUpSteps";
import { Step } from "@faire/retailer-visitor-shared/views/SignUp/Step";

export const ENDING_STEP_PERCENTAGE = 95;

const getOptionalStepPercentage = (
  prevMandatoryPercentage: number,
  nextMandatoryPercentage: number,
  currentOptionalStepCount: number,
  totalOptionalStepCountInBetween: number
) => {
  const totalPercentageIncrease =
    nextMandatoryPercentage - prevMandatoryPercentage;
  const percentageIncreasePerOptionalStep =
    totalPercentageIncrease / (totalOptionalStepCountInBetween + 1);
  return (
    prevMandatoryPercentage +
    percentageIncreasePerOptionalStep * currentOptionalStepCount
  );
};

// Total 6 mandatory steps for now
// There are conditional steps in between
// 15% increase for main steps
// Divide evenly for optional steps
const coreSignUpStepProgressionPercentage = {
  [Step.PERSONAL_INFO]: 15,
  [Step.NOTIFY_ME]: getOptionalStepPercentage(15, ENDING_STEP_PERCENTAGE, 1, 1),
  [Step.BUSINESS_TYPE]: 30,
  [Step.STORE_INFO]: 45,
  [Step.STORE_TYPE_S1]: getOptionalStepPercentage(45, 60, 1, 1),
  [Step.OPENING_YEAR]: 60,
  [Step.OPENING_MONTH]: getOptionalStepPercentage(60, 75, 1, 3),
  [Step.FAIRE_DIRECT_SURVEY]: getOptionalStepPercentage(60, 75, 2, 3),
  [Step.ANNUAL_SALES]: getOptionalStepPercentage(60, 75, 3, 3),
  [Step.RESELLER_CERT]: 75,
  [Step.SELECT_NET_TERMS]: getOptionalStepPercentage(
    75,
    ENDING_STEP_PERCENTAGE,
    1,
    3
  ),
  [Step.SCC_AGREEMENT]: getOptionalStepPercentage(
    75,
    ENDING_STEP_PERCENTAGE,
    2,
    3
  ),
  [Step.SCC_PERSONAL_INFO_FORM]: getOptionalStepPercentage(
    75,
    ENDING_STEP_PERCENTAGE,
    3,
    3
  ),
};

const endingStepProgressionPercentage = () => {
  const endingSignUpPercentage: Partial<Record<Step, number>> = {};
  endingSteps.forEach((step) => {
    endingSignUpPercentage[step] = ENDING_STEP_PERCENTAGE;
  });
  return endingSignUpPercentage;
};

export const signUpStepProgressionPercentage = {
  ...coreSignUpStepProgressionPercentage,
  ...endingStepProgressionPercentage(),
};
